import { render, staticRenderFns } from "./EditCommunicationList.vue?vue&type=template&id=76eb8d80"
import script from "./EditCommunicationList.vue?vue&type=script&lang=js"
export * from "./EditCommunicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports